import styled from "styled-components";
import { TimelineEventDefinitions } from "../../Definitions";
import { TimelineEvent } from "../../TimelineEvents.types";

const DetailItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const DetailLabel = styled.div`
  font-weight: 500;
  margin-right: 8px;
  min-width: 150px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const DetailValue = styled.div`
  white-space: pre-wrap;
  overflow-y: auto;
`;

const EventDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  flex: 1 1 auto;
`;

const Description = styled.div`
  max-height: none;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

const SectionHeader = styled.h3`
  margin: 0px;
  margin-bottom: 10px;
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 10px 0px;
`;

export const FlyoutDetailsTab: React.FC<{
  defaultEventData: TimelineEvent;
}> = ({ defaultEventData }) => {
  return (
    <StyledContent>
      <SectionHeader>Event Details</SectionHeader>
      <EventDetails>
        {TimelineEventDefinitions.filter(
          (col) => col.dataField !== "description"
        ).map((col) => {
          const key = col.dataField as keyof TimelineEvent;
          const label = col.caption;
          const value = col?.render
            ? col.render({ rowData: defaultEventData })
            : String(defaultEventData[key]);

          return (
            <DetailItem key={key}>
              <DetailLabel>{label}</DetailLabel>
              <DetailValue>{value}</DetailValue>
            </DetailItem>
          );
        })}
        <DetailItem>
          <DetailLabel>Description</DetailLabel>
        </DetailItem>
        <Description>
          <DetailValue>{defaultEventData.description || "None"}</DetailValue>
        </Description>
      </EventDetails>
    </StyledContent>
  );
};
